/**
 * UnloadingMethodFieldButton - Unloading method field button using existing hooks
 */

import {useUnloadingMethod} from '@hconnect/tuc-processes/fields/unloadingMethod/useUnloadingMethod'
import React from 'react'
import {useTranslation} from 'react-i18next'

import {FieldButton} from '../../FieldButton'

import {getUnloadingMethodText} from './unloadingMethodUtils'

interface UnloadingMethodFieldButtonProps {
  onClick: () => void
  requiresApproval?: boolean
  isReadOnly?: boolean
  isChanged?: boolean
}

export const UnloadingMethodFieldButton: React.FC<UnloadingMethodFieldButtonProps> = ({
  onClick,
  requiresApproval = false,
  isReadOnly = false,
  isChanged = false
}) => {
  const {t} = useTranslation()
  const {selectedUnloadingMethod} = useUnloadingMethod()

  // Following useRmcOrderEditLogic pattern
  const displayValue = getUnloadingMethodText(t, selectedUnloadingMethod ?? undefined) || null

  return (
    <FieldButton
      label={t('orderIntake.rmc.orderManagement.editSteps.labels.unloadingMethod', 'Unloading method')}
      value={displayValue}
      onClick={onClick}
      requiresApproval={requiresApproval}
      isReadOnly={isReadOnly}
      isChanged={isChanged}
    />
  )
}
